module.exports = __webpack_public_path__ + "img/yh.fecbeed2.png";